import { Grid } from "@mui/material";
import * as React from "react";
import { Create, required, TextInput } from "react-admin";
import { SimpleForm } from "src/enterprise/ra-rbac";
import { TagCreateComponent } from "./TagComponent";

export const TagCreate = () => {
  return (
    <Create component={TagCreateComponent}>
      <SimpleForm>
        <Grid container rowSpacing={1} columnSpacing={2}>
          <Grid item sm={12} lg={8}>
            <TextInput source="name" validate={required()} />
          </Grid>
        </Grid>
      </SimpleForm>
    </Create>
  );
};
